<template>
  <div class="container-fluid">
    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <div>
        <vk-offcanvas-close @click="hideOffCanvasFunc"></vk-offcanvas-close>
        <h3>Warning Info</h3>
        <hr />

        <div v-show="warningItem != null">
          <div class="inverterInfo"><b> DeviceID </b> <span>{{warningItem && warningItem.DeviceID}}</span></div>
          <div class="inverterInfo"><b> Name </b> <span>{{warningItem && warningItem.installation.name}}</span></div>
          <div class="inverterInfo"><b> StartTime </b> <span>{{warningItem && warningItem.StartTime}}</span></div>
          <div class="inverterInfo"><b> EndTime </b> <span>{{warningItem && warningItem.EndTime}}</span></div>
          <div class="inverterInfo"><b> Fault </b> <span>{{warningItem && warningItem.Fault}}</span></div>
          <div class="inverterInfo"><b> Severity </b> <span>{{warningItem && warningItem.Severity}}</span></div>
          <div class="inverterInfo"><b> Status </b> <span>{{warningItem && warningItem.Status}}</span></div>
        </div>
      </div>
    </vk-offcanvas>

    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px;"
      >
        <h2 style="flex: 1;">Alarms</h2>
      </div>

      <div>
        <Warnings
          @showOffCanvas="showOffCanvasFunc"
          @onRowClick="openWarningInfo"
        ></Warnings>
      </div>
    </div>
  </div>
</template>

<script>
import Warnings from "./warnings";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
} from "element-ui";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
export default {
  name: "",
  components: {
    Warnings,
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      errors: [],
      installationOptions: [],
      showOffCanvas: false,
      warningItem: null
    };
  },
  computed: {},
  methods: {
    openWarningInfo(row) {
      this.warningItem = row;
      console.log(row)
    },
    showOffCanvasFunc() {
      this.showOffCanvas = true;
    },
    hideOffCanvasFunc() {
      this.showOffCanvas = false;
    },
    validate() {
      var err = [];
      for (let [field, value] of Object.entries(this.form)) {
        // console.log(`${field}: ${value}`);
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        switch (field) {
          case "user":
            if (value === "null" || value === "") {
              err[field] = "Select a user.";
            }
            break;
          case "invoiceType":
            if (value === "null" || value === "") {
              err[field] = "Choose invoice type.";
            }
            break;
          case "installation":
            if (value === "null" || value === "") {
              err[field] = "Select an installation.";
            }
            break;
          case "amount":
            if (value === "null" || value === "") {
              err[field] = "Amount cannot be empty.";
            }
            break;
          case "comment":
            if (value === "null" || value === "") {
              err[field] = "Description can not be empty.";
            }
            break;
          case "period":
            if (value === "null" || value === "") {
              err[field] = "Select billing period.";
            }
            break;
          default:
            break;
        }
      }
      this.errors = err;
    },
    installationSelected(installation) {
      let modelMap = {
        OS: "OUTRIGHT",
        ES: "ENERGY AS A SERVICE",
        LO: "LEASE TO OWN"
      };
      this.form["comment"] = `${
        modelMap[installation.deviceRequest.paymentModel]
      }`;
    },
    contactSearch(queryString, cb) {
      let contacts = this.contactList;
      var results = queryString
        ? contacts.filter(contact => this.createFilter(queryString, contact))
        : contacts;
      cb(results);
    },
    createFilter(queryString, contact) {
      return (
        `${contact.First_Name} ${contact.Last_Name}`
          .toLowerCase()
          .indexOf(queryString.toLowerCase()) > -1
      );
    },
    contactSelected(contact) {
      //   console.log({ contact });
      this.form.user = contact;
      this.form.installation = null;
      if (contact.installations && contact.installations.length > 0) {
        this.installationOptions = contact.installations;
      }
    },
    fetchUsers() {
      const HTTP = this.$httpUtils.instance;
      let container = this;
      let filter = {
        include: { installations: ["deviceRequest", "deviceType"] },
        roleType: "customer"
      };
      const url = `/users?filter=${JSON.stringify(filter)}`+`&filter[order]=id DESC`;
      HTTP.get(url)
        .then(response => {
          container.contactList = response.data.map(x => ({
            ...x,
            First_Name: x.firstName,
            Last_Name: x.lastName,
            value: `${x.firstName} ${x.lastName}`
          }));
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  async mounted() {
    this.fetchUsers();
  }
};
</script>

<style lang="scss" scoped>
.inverterInfo {
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/warnings/index.vue